export default "__VITE_ASSET__CIInpuhM__"